export default "__VITE_PUBLIC_ASSET__8d5f1426__"